<div class="header">
    <h2>{{isEditingMode ? 'Edit':'Create'}} Contact</h2>
  </div>
  <mat-card>
    
    <div class="mat-elevation-z0">
      <h3 class="sub-heading inline-item">Contact Form</h3>
        <form [formGroup]="createContactForm" (ngSubmit)="createContact()" class="contact-form">
          <div class="block">
            <mat-form-field appearance="outline" class="full-width">
              <input matInput formControlName="name" placeholder="Contact Name" />
            </mat-form-field>
          </div>
          <div class="block">
            <mat-form-field appearance="outline" class="full-width">
              <input matInput formControlName="email" placeholder="Contact Email" />
            </mat-form-field>
          </div>
          <div class="block">
            <button mat-flat-button type="submit" color="primary"
            [disabled]="createContactForm.invalid">{{isEditingMode ? 'Save' : 'Create'}}
            Contact</button>
          </div>
        </form>
    </div>
  </mat-card>
  
